module.exports = __webpack_public_path__ + "img/symbol_5.2fc785b1.png";